import { render, staticRenderFns } from "./UpdateImportTradeIn.vue?vue&type=template&id=23a1282e&"
import script from "./UpdateImportTradeIn.vue?vue&type=script&lang=js&"
export * from "./UpdateImportTradeIn.vue?vue&type=script&lang=js&"
import style0 from "./UpdateImportTradeIn.vue?vue&type=style&index=0&id=23a1282e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports